import http from './http';

export default {
  getPayload(url) {
    return http().get(url)
  },
}
